import { FC, PropsWithChildren, ReactNode, useEffect } from "react";
import {
  Header,
  HeaderMenu,
  HeaderMenuItemProps,
  Toast,
} from "@metsooutotec/modes-react-components";
import { useMsal } from "@azure/msal-react";
import { Outlet, useLocation, useNavigate, useNavigation } from "react-router-dom";
import ErrorBoundary from "../error-handlers/error-boundary";

const MainLayout: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const userName = accounts.length > 0 ? accounts[0].username : "test";

  const {pathname} = useLocation()

  const iotDevicesMenu: HeaderMenuItemProps[] = [
    {
      text: "Sensor Batches",
      onClick: (e: any) => {
        navigate("/sensor-batches");
      },
    },
  ];

  const provisionsMenu: HeaderMenuItemProps[] = [
    {
      text: "Provisioning Events",
      onClick: (e: any) => {
        navigate("/provision-events");
      },
    },
    {
      text: "Liner Material Library",
      onClick: (e: any) => {
        navigate("/liner-material-library");
      },
    },
  ];

  const stockManagementMenu: HeaderMenuItemProps[] = [
    {
      text: "Stock Management",
      onClick: (e: any) => {
        navigate("/stock-management");
      },
    },
    {
      text: "Stock Allocation",
      onClick: (e: any) => {
        navigate("/stock-management/stock-allocation");
      },
    },
    {
      text: "Dispatch",
      onClick: (e: any) => {
        navigate("/stock-management/dispatch");
      },
    },
    {
      text: "Dispatch History",
      onClick: (e: any) => {
        navigate("/stock-management/dispatch-history");
      },
    },
  ];

  const userManagementMenu: HeaderMenuItemProps[] = [
    {
      text: "Users",
      onClick: (e: any) => {
        navigate("/users-management");
      },
    },
  ];

  const leftMenus: ReactNode = (
    <>
      <HeaderMenu
        items={[]}
        onChevronClick={function noRefCheck() {}}
        onClick={() => navigate("/customers")}
        text="Customers"
      />

      <HeaderMenu
        items={iotDevicesMenu}
        onChevronClick={function noRefCheck() {}}
        text="IoT Devices"
      />

      <HeaderMenu
        items={provisionsMenu}
        onChevronClick={function noRefCheck() {}}
        text="Provisioning"
      />

      <HeaderMenu
        items={stockManagementMenu}
        onChevronClick={function noRefCheck() {}}
        text="Stock Management"
      />

      <HeaderMenu
        items={userManagementMenu}
        onChevronClick={function noRefCheck() {}}
        text="Users Management"
      />
    </>
  );

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  const dismissText = "DISMISS";

  return (
    <Header
      title="WearSense Admin Portal"
      username={userName}
      logoHref={"/"}
      leftItems={leftMenus}
      additionalProfileMenuItems={[
        {
          onClick: handleLogout,
          iconName: "icon-logout-16",
          text: "Log out",
          additionalProps: { "data-cy": "header-menu-item-additional-item-1" },
        },
      ]}
    >
      <ErrorBoundary navigationPath={pathname}>
        <Outlet />
        <Toast dismissText={dismissText} />
      </ErrorBoundary>
    </Header>
  );
};
export default MainLayout;
